/* tslint:disable:max-line-length */
import * as React from 'react'

export const PAYMENT = {
  iDeal: (
    <g>
      <path
        d="M0,34.2h264.1c179.2,0,247.9,97.9,247.9,221.3c0,148.1-95.9,222.3-247.9,222.3H0V34.2z M25.6,59.8v392.5h238.5
                c144,0,222.3-67.1,222.3-196.8c0-133.3-84.9-195.8-222.3-195.8L25.6,59.8L25.6,59.8z"
      />
      <path d="M57.6,284.4h76.3v135.9H57.6V284.4z" />
      <circle cx="95.7" cy="215.9" r="47.4" fill="#222222" />
      <path
        fill="#D50072"
        d="M294,238.1v22h-54.4v-88.3h52.7v22h-30.7V204h29v22h-29v12.1H294L294,238.1z M303.5,260.1l26.6-88.3h31.3
                l26.6,88.3h-22.9l-5-17.1h-28.8l-5,17.1H303.5L303.5,260.1z M337.8,221.1h15.9l-7.3-25h-1.3L337.8,221.1L337.8,221.1z M399.1,171.8
                h22v66.3h32.6C444.8,117.8,350.1,91.8,264.1,91.8h-91.7v80.1H186c24.7,0,40.1,16.8,40.1,43.8c0,27.9-15,44.5-40.1,44.5h-13.6v160.2
                h91.7c139.8,0,188.5-64.9,190.2-160.2h-55.2V171.8L399.1,171.8z M172.3,193.8v44.3h13.6c9.4,0,18.1-2.7,18.1-22.5
                c0-19.3-9.7-21.8-18.1-21.8H172.3z"
      />
    </g>
  ),

  masterCard: (
    <g>
      <path
        fill="#231F20"
        d="M93.8,452.4v-26.3c0.6-8.6-5.9-16-14.5-16.6c-0.7,0-1.3,0-2,0c-5.9-0.4-11.5,2.5-14.7,7.4
			c-2.9-4.8-8.2-7.7-13.8-7.4c-4.9-0.2-9.6,2.1-12.3,6.2v-5.2h-9.1v41.9h9.2v-23c-0.7-5.4,3-10.3,8.4-11c0.6-0.1,1.2-0.1,1.9-0.1
			c6,0,9.1,3.9,9.1,11v23.3h9.2v-23.2c-0.7-5.4,3.1-10.3,8.5-11c0.6-0.1,1.2-0.1,1.8-0.1c6.2,0,9.2,3.9,9.2,11v23.3L93.8,452.4z
			 M229.8,410.5h-15v-12.7h-9.2v12.7h-8.3v8.3h8.5v19.3c0,9.7,3.8,15.5,14.5,15.5c4,0,8-1.1,11.4-3.2l-2.6-7.8
			c-2.4,1.5-5.2,2.3-8.1,2.4c-4.4,0-6-2.8-6-7v-19.1h14.9L229.8,410.5z M307.5,409.5c-4.5-0.1-8.8,2.2-11,6.1v-5.1h-9v41.9h9.1
			v-23.5c0-6.9,3-10.8,8.8-10.8c1.9,0,3.9,0.3,5.7,1.1l2.8-8.8c-2.1-0.7-4.3-1.1-6.5-1.1L307.5,409.5z M190.1,413.9
			c-5.2-3.1-11.1-4.6-17.1-4.4c-10.6,0-17.5,5.1-17.5,13.4c0,6.8,5.1,11,14.4,12.3l4.4,0.6c5,0.7,7.4,2,7.4,4.4
			c0,3.2-3.3,5.1-9.5,5.1c-5,0.1-9.9-1.4-13.9-4.4l-4.4,7.1c5.3,3.7,11.7,5.6,18.1,5.4c12.1,0,19.1-5.7,19.1-13.7
			c0-8-5.5-11.2-14.6-12.5l-4.4-0.6c-3.9-0.5-7.1-1.3-7.1-4.1c0-2.8,3-4.9,8-4.9c4.6,0.1,9.1,1.3,13.1,3.6L190.1,413.9z M434,409.5
			c-4.5-0.1-8.8,2.2-11,6.1v-5.1h-9v41.9h9.1v-23.5c0-6.9,3-10.8,8.8-10.8c1.9,0,3.9,0.3,5.7,1.1l2.8-8.8c-2.1-0.7-4.3-1.1-6.5-1.1
			L434,409.5z M316.6,431.4c-0.4,11.7,8.7,21.5,20.4,21.9c0.7,0,1.3,0,2,0c5.5,0.3,10.8-1.5,15.1-5l-4.4-7.4
			c-3.1,2.4-7,3.7-10.9,3.8c-7.4-0.6-12.9-7.1-12.3-14.5c0.5-6.6,5.7-11.8,12.3-12.3c4,0,7.8,1.4,10.9,3.8l4.4-7.4
			c-4.2-3.5-9.6-5.3-15.1-5c-11.7-0.7-21.6,8.3-22.3,19.9c0,0.7,0,1.3,0,2V431.4z M401.9,431.4v-20.8h-9.1v5.1
			c-3.1-4-8-6.3-13.1-6.1c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9c5.1,0.2,10-2.1,13.1-6.1v5.1h9.1V431.4z M368,431.4
			c0.4-7,6.4-12.3,13.4-11.9c7,0.4,12.3,6.4,11.9,13.4c-0.4,6.7-5.9,11.9-12.6,11.9c-6.9,0.1-12.6-5.5-12.7-12.4
			C368,432,368,431.7,368,431.4z M258.1,409.5c-12.1,0.2-21.8,10.1-21.6,22.2s10.1,21.8,22.2,21.6l0,0c6.3,0.3,12.5-1.7,17.4-5.7
			l-4.4-6.7c-3.5,2.8-7.7,4.3-12.2,4.4c-6.3,0.5-11.8-4-12.5-10.2h31.1c0-1.1,0-2.3,0-3.5c0-13.1-8.1-21.9-19.9-21.9L258.1,409.5z
			 M258.1,417.6c5.7-0.1,10.5,4.4,10.6,10.2c0,0,0,0,0,0h-21.9c0.3-5.8,5.3-10.4,11.1-10.2H258.1z M486.3,431.5v-37.7h-8.8v21.9
			c-3.1-4-8-6.3-13.1-6.1c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9c5.1,0.2,10-2.1,13.1-6.1v5.1h8.8V431.5z M501.5,446.3
			c0.6,0,1.1,0.1,1.7,0.3c0.5,0.2,1,0.5,1.4,0.9c0.4,0.4,0.7,0.8,0.9,1.3c0.4,1,0.4,2.2,0,3.2c-0.2,0.5-0.5,0.9-0.9,1.3
			c-0.4,0.4-0.9,0.7-1.4,0.9c-0.5,0.2-1.1,0.4-1.7,0.4c-1.7,0-3.2-1-3.9-2.5c-0.4-1-0.4-2.2,0-3.2c0.2-0.5,0.5-0.9,0.9-1.3
			c0.4-0.4,0.9-0.7,1.4-0.9c0.6-0.2,1.2-0.3,1.8-0.3H501.5z M501.5,453.7c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.7
			c1.1-1.2,1.1-3.1,0-4.4c-0.3-0.3-0.6-0.5-1-0.7c-0.4-0.2-0.8-0.3-1.3-0.3c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.8,0.4-1.1,0.7
			c-1.1,1.2-1.1,3.1,0,4.4c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.9,0.3,1.4,0.3L501.5,453.7z M501.7,448.5c0.4,0,0.8,0.1,1.1,0.4
			c0.3,0.2,0.4,0.6,0.4,0.9c0,0.3-0.1,0.6-0.3,0.8c-0.3,0.2-0.6,0.4-0.9,0.4l1.3,1.4h-1l-1.2-1.4h-0.4v1.4h-0.8v-3.9L501.7,448.5z
			 M500.8,449.2v1.1h1c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.1-0.3,0-0.4c0.1-0.1,0.1-0.3,0-0.4c-0.2-0.1-0.4-0.1-0.5,0L500.8,449.2z
			 M452.6,431.5c0.4-7,6.4-12.3,13.4-11.9c7,0.4,12.3,6.4,11.9,13.4c-0.4,6.7-5.9,11.9-12.6,11.9c-6.9,0.1-12.6-5.5-12.7-12.4
			C452.6,432.1,452.6,431.8,452.6,431.5z M145.1,431.5v-20.9H136v5.1c-3.1-4-8-6.3-13.1-6.1c-12.1,0-21.9,9.8-21.9,21.9
			s9.8,21.9,21.9,21.9c5.1,0.2,10-2.1,13.1-6.1v5.1h9.1L145.1,431.5z M111.3,431.5c0.4-7,6.4-12.3,13.4-11.9
			c7,0.4,12.3,6.4,11.9,13.4c-0.4,6.7-5.9,11.9-12.6,11.9c-6.9,0.1-12.7-5.4-12.8-12.3C111.1,432.2,111.2,431.8,111.3,431.5
			L111.3,431.5z"
      />
      <rect x="187" y="91.6" fill="#FF5F00" width="137.9" height="247.8" />
      <path
        id="_Path_"
        fill="#EB001B"
        d="M195.8,215.6c-0.1-48.4,22.1-94.1,60.2-123.9C187.6,37.8,88.5,49.7,34.7,118.2
				S-7.2,285.7,61.2,339.5c57.2,44.9,137.6,44.9,194.8,0C218,309.6,195.8,263.9,195.8,215.6z"
      />
      <path
        fill="#F79E1B"
        d="M511,215.6c0,87-70.6,157.6-157.6,157.6c-35.3,0-69.6-11.9-97.4-33.7c68.4-53.8,80.3-152.9,26.5-221.3
				c-7.8-9.9-16.7-18.8-26.5-26.5c68.4-53.8,167.5-41.9,221.3,26.5C499.1,145.9,511,180.2,511,215.6L511,215.6z"
      />
      <path
        fill="#F79E1B"
        d="M495.9,313.2v-5.1h2.1v-1.1h-5.2v1.1h2.2v5.1L495.9,313.2z M506.1,313.2v-6.1h-1.6l-1.8,4.4l-1.8-4.4
				h-1.4v6.1h1.1v-4.6l1.7,4h1.2l1.7-4v4.6L506.1,313.2z"
      />
    </g>
  ),

  visa: (
    <g>
      <path
        fill="#2566AF"
        d="M222,336.3h-41.8l26.1-160.5h41.8L222,336.3z M145,175.8l-39.8,110.4l-4.7-23.8l0,0 l-14.1-72.2c0,0-1.7-14.4-19.8-14.4H0.8L0,178.5c0,0,20.1,4.2,43.7,18.3L80,336.3h43.5L190,175.8L145,175.8L145,175.8z M473.6,336.3H512l-33.4-160.5H445c-15.5,0-19.3,12-19.3,12l-62.3,148.5h43.6l8.7-23.8h53.1L473.6,336.3L473.6,336.3z M427.7,279.5l22-60.1l12.3,60.1H427.7z M366.6,214.4l6-34.5c0,0-18.4-7-37.6-7c-20.7,0-70,9.1-70,53.1c0,41.5,57.8,42,57.8,63.7 c0,21.8-51.8,17.9-68.9,4.1l-6.2,36c0,0,18.7,9.1,47.2,9.1c28.5,0,71.5-14.8,71.5-54.9c0-41.7-58.3-45.6-58.3-63.7 C308.1,202.2,348.8,204.6,366.6,214.4L366.6,214.4z"
      />
      <path
        fill="#E6A540"
        d="M100.5,262.4l-14.1-72.2c0,0-1.7-14.4-19.8-14.4H0.8L0,178.5c0,0,31.6,6.6,62,31.1 C91,233.1,100.5,262.4,100.5,262.4z"
      />
    </g>
  ),

  paypal: (
    <g>
      <path
        fill="#27346A"
        d="M408.5,38.6C384.8,11.6,341.9,0,287.1,0H128c-11.2,0-20.7,8.1-22.5,19.2L39.2,439.4
                c-1.3,8.3,5.1,15.8,13.5,15.8H151l24.7-156.5l-0.8,4.9c1.8-11.1,11.2-19.2,22.4-19.2H244c91.7,0,163.5-37.2,184.5-145
                c0.6-3.2,1.2-6.3,1.6-9.3c-2.6-1.4-2.6-1.4,0,0C436.3,90.3,430,63.1,408.5,38.6"
      />
      <path
        fill="#27346A"
        d="M213.2,115.7c2.7-1.3,5.6-1.9,8.6-1.9h124.7c14.8,0,28.5,1,41.1,3c3.5,0.6,7,1.2,10.5,2
                c4.9,1.1,9.8,2.4,14.6,4c6.2,2.1,12,4.5,17.3,7.3c6.2-39.8,0-66.9-21.6-91.5C384.8,11.6,341.9,0,287.1,0H128
                c-11.2,0-20.7,8.2-22.5,19.2L39.2,439.4c-1.3,8.3,5.1,15.8,13.5,15.8H151l51.2-324.6C203.2,124.1,207.3,118.6,213.2,115.7
                L213.2,115.7z"
      />
      <path
        fill="#2790C3"
        d="M428.4,139.4c-21,107.7-92.8,145-184.5,145h-46.7c-11.2,0-20.7,8.2-22.4,19.2l-30.7,194.6
                c-1.1,7.3,4.5,13.8,11.8,13.8h82.8c9.8,0,18.1-7.1,19.7-16.8l0.8-4.2l15.6-98.9l1-5.5c1.5-9.7,9.9-16.8,19.7-16.8h12.4
                c80.2,0,143-32.6,161.4-126.8c7.7-39.4,3.7-72.3-16.6-95.4c-6.1-7-13.8-12.8-22.7-17.5C429.6,133.1,429.1,136.2,428.4,139.4
                L428.4,139.4z"
      />
      <path
        fill="#1F264F"
        d="M408.1,121.3c-3.3-1-6.6-1.8-9.9-2.5c-3.5-0.8-7-1.4-10.5-2c-12.6-2-26.4-3-41.2-3H221.8
                c-3,0-5.9,0.7-8.6,2c-5.9,2.8-10.1,8.4-11.1,14.9l-26.5,168.1l-0.8,4.9c1.7-11.1,11.2-19.2,22.4-19.2H244
                c91.7,0,163.5-37.2,184.5-145c0.6-3.2,1.1-6.3,1.6-9.3c-5.3-2.8-11.1-5.2-17.3-7.3C411.3,122.3,409.7,121.8,408.1,121.3"
      />
    </g>
  ),
  klarna: (
    <>
      <g id="Badges">
        <g id="Logo" transform="translate(-142 -122)">
          <g
            id="Badge-_x2F_-xx_x5F_xx-_x2F_-pay_x5F_later-_x2F_-standard-_x2F_pink"
            transform="translate(142 122)"
          >
            <g id="BG-_x2F_-Radius-5">
              <defs>
                <filter
                  id="Adobe_OpacityMaskFilter"
                  width="96"
                  height="64"
                  x="-372"
                  y="266.3"
                  filterUnits="userSpaceOnUse"
                >
                  <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
                </filter>
              </defs>
              <mask
                id="mask-2"
                width="96"
                height="64"
                x="-372"
                y="266.3"
                maskUnits="userSpaceOnUse"
              >
                <g filter="url(#Adobe_OpacityMaskFilter)">
                  <path
                    id="path-1"
                    d="M-367 266.3h86c2.8 0 5 2.2 5 5v54c0 2.8-2.2 5-5 5h-86c-2.8 0-5-2.2-5-5v-54c0-2.8 2.2-5 5-5z"
                    fill="#fff"
                  />
                </g>
              </mask>
              <g id="Color-_x2F_-Pink" mask="url(#mask-2)">
                <path id="BG_1_" fill="#eb6f93" d="M-372 266.3h96v64h-96z" />
              </g>
            </g>
            <g
              id="Logo-_x2F_-White-_x28_Clean_x29_-Copy"
              transform="translate(20 44)"
            >
              <path
                id="Shape"
                d="M-361.8 266.3h-2.9c0 2.3-1.1 4.5-2.9 5.9l-1.1.8 4.4 5.9h3.6l-4-5.5c1.8-1.8 2.9-4.4 2.9-7.1z"
                fill="#fff"
              />
              <path
                id="Rectangle-path"
                d="M-372 266.3h2.9v12.6h-2.9z"
                fill="#fff"
              />
              <path
                id="Rectangle-path_1_"
                d="M-359.9 266.3h2.8v12.6h-2.8z"
                fill="#fff"
              />
              <path
                id="Shape_1_"
                d="M-333 269.9c-1 0-2 .3-2.7 1.2v-1h-2.6v8.7h2.7v-4.6c0-1.3.9-2 2-2 1.2 0 1.8.7 1.8 2v4.6h2.6v-5.6c-.1-1.9-1.7-3.3-3.8-3.3z"
                fill="#fff"
              />
              <path
                id="Shape_2_"
                d="M-348.8 270.2v.6c-.7-.5-1.6-.8-2.6-.8-2.6 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6c1 0 1.9-.3 2.6-.8v.6h2.6v-8.7h-2.6zm-2.4 6.6c-1.3 0-2.4-1-2.4-2.2s1.1-2.2 2.4-2.2c1.3 0 2.4 1 2.4 2.2s-1.1 2.2-2.4 2.2z"
                fill="#fff"
              />
              <path
                id="Shape_3_"
                d="M-342.1 271.3v-1.1h-2.7v8.7h2.7v-4.1c0-1.4 1.5-2.1 2.5-2.1v-2.5c-1 0-2 .4-2.5 1.1z"
                fill="#fff"
              />
              <path
                id="Shape_4_"
                d="M-321.1 270.2v.6c-.7-.5-1.6-.8-2.6-.8-2.6 0-4.6 2.1-4.6 4.6s2.1 4.6 4.6 4.6c1 0 1.9-.3 2.6-.8v.6h2.6v-8.7h-2.6zm-2.4 6.6c-1.3 0-2.4-1-2.4-2.2s1.1-2.2 2.4-2.2c1.3 0 2.4 1 2.4 2.2 0 1.2-1.1 2.2-2.4 2.2z"
                fill="#fff"
              />
              <path
                id="Shape_5_"
                d="M-315.7 275.8c-.9 0-1.7.7-1.7 1.6 0 .9.7 1.6 1.7 1.6s1.7-.7 1.7-1.6c0-.8-.8-1.6-1.7-1.6z"
                fill="#fff"
              />
            </g>
            <g
              id="Icons-_x2F_-Pay-later-_x2F_-White"
              transform="translate(22 15)"
            >
              <path
                id="_Path_"
                d="M-371.3 267.8c3.8-.4 7.7-.6 11.5-.6 2.7 0 4.7.1 7.3.3.2 0 1.1.1 1.2.1.5 0 .8.1 1.2.1 1.2.1 2.2.1 3.2.1.4 0 .7-.3.7-.7s-.3-.7-.7-.7c-1 0-2 0-3.1-.1-.4 0-.7 0-1.2-.1-.2 0-1-.1-1.2-.1-2.7-.2-4.7-.3-7.4-.3-4.1 0-8.2.3-12.3.7-.3 0-.6.3-.6.7v2.1c0 .1 0 .2.1.3.5 1 .9 2.1 1 3.2.2 3.5.5 5.7 1.6 7.9 1.6 3.2 4.5 5 8.8 5 7.6 0 9.8-1.7 11.4-6.7 0-.1.2-.6.3-.8.1-.3.2-.6.3-.8-.1.3 1.1-3.4 1.4-4 .4-.9.7-1.3 1-1.3.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7-1 0-1.7.7-2.3 2.1-.3.7-1.6 4.4-1.4 4.1-.1.3-.2.5-.3.8-.1.2-.2.7-.3.8-.7 2.3-1.3 3.3-2.4 4.1-1.5 1.1-3.9 1.7-7.7 1.7-3.8 0-6.2-1.5-7.6-4.2-1-2-1.3-4-1.5-7.4-.1-1.3-.5-2.5-1.1-3.6v-1.3z"
                fill="#fff"
              />
              <path
                id="Combined-Shape"
                d="M-360.9 282.1c-1.7.1-3.3-.6-4.5-1.7-2.4-2.4-2.4-6.3-2.4-6.5-.1-.6-.1-1.2-.1-1.8-.1-.6.1-1.2.5-1.6.4-.4.9-.7 1.5-.8 1.7-.2 4.2-.3 5.9-.3 4.3-.1 6.7.2 7.6.8 1.3.8 1.1 2.1 0 5.6l-.3.8c-1 3.5-1.7 5.5-8.2 5.5zm2.4-11.6l-6.5 8c-.2.3-.2.7.1.9.3.2.7.2 1-.1l6.5-8c.2-.3.2-.7-.1-.9-.3-.2-.7-.2-1 .1zm-4.3-.3l-3.8 4.6c-.2.3-.2.7.1.9.3.2.7.2 1-.1l3.8-4.6c.2-.3.2-.7-.1-.9s-.8-.1-1 .1z"
                fill="#fff"
              />
              <path
                id="_Path_2"
                d="M-322.2 267.8v1.3c-.6 1.1-1 2.3-1.1 3.6-.2 3.4-.5 5.5-1.5 7.4-1.4 2.7-3.8 4.2-7.6 4.2-3.9 0-6.3-.6-7.7-1.7-1.1-.9-1.7-1.9-2.4-4.1 0-.1-.2-.6-.3-.8-.1-.3-.2-.6-.3-.8.1.3-1.1-3.4-1.4-4.1-.6-1.4-1.2-2.1-2.3-2.1-.4 0-.7.3-.7.7 0 .4.3.7.7.7.3 0 .6.3 1 1.3.3.6 1.5 4.3 1.4 4 .1.2.2.5.3.8.1.2.2.7.3.8 1.6 5 3.9 6.7 11.5 6.7 4.3 0 7.2-1.8 8.8-5 1.1-2.2 1.5-4.4 1.7-7.9.1-1.1.5-2.2 1-3.2.1-.1.1-.2.1-.3v-2.1c0-.3-.3-.6-.6-.7-4.1-.5-8.2-.7-12.3-.7-2.7 0-4.7.1-7.4.3-.2 0-1.1.1-1.2.1-.5 0-.8.1-1.2.1-1.1.1-2.1.1-3.1.1-.4 0-.7.3-.7.7s.3.7.7.7c1.1 0 2.1 0 3.2-.1.4 0 .7 0 1.2-.1.2 0 1-.1 1.2-.1 2.7-.2 4.6-.3 7.3-.3 3.7 0 7.5.2 11.4.6z"
                fill="#fff"
              />
              <path
                id="Combined-Shape_1_"
                d="M-332.6 282.1c-6.5 0-7.2-2-8.3-5.6l-.3-.8c-1.1-3.5-1.3-4.7 0-5.6 1-.6 3.3-.9 7.6-.8 1.7 0 4.2.1 5.9.3.6.1 1.1.3 1.5.8.4.5.6 1 .5 1.6 0 .6 0 1.3-.1 1.9 0 .1 0 4.1-2.4 6.5-1.1 1.1-2.7 1.7-4.4 1.7zm-3.8-11.9l-3.8 4.6c-.2.3-.2.7.1.9.3.2.7.2 1-.1l3.8-4.6c.2-.3.2-.7-.1-.9s-.8-.1-1 .1zm4.3.3l-6.5 8c-.2.3-.2.7.1.9.3.2.7.2 1-.1l6.5-8c.2-.3.2-.7-.1-.9-.3-.2-.7-.2-1 .1z"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </>
  ),
  bancontact: (
    <g>
      <path
        fill="#FFFFFF"
        stroke="#2D78BB"
        strokeWidth="1.889"
        strokeMiterlimit="2.613"
        d="M256,103.7h218.1c28.9,0,37.9,21.2,37.9,36.2v232.2c0,14.4-9,36.2-37.9,36.2H37.9
                C9.3,408.3,0,386.5,0,372.1V139.9c0-15,9.3-36.2,37.9-36.2H256L256,103.7z"
      />
      <path
        fill="#2D78BB"
        d="M153.4,280.3H233l44.6-47.7h79.9l-67.9,75.7h-251v-50.6h134.6L153.4,280.3z"
      />
      <path
        fill="#F8E14B"
        d="M357.5,232.6h-79.9l-44.6,48h-80.2l67.9-75.7h251.2v50.3H337.3L357.5,232.6z"
      />
      <path
        fill="#2D78BB"
        d="M439.7,186.2c-3.6,2.3-8.4,3.4-12.9,3.4c-12.9,0-24.4-9.6-24.4-22.9c0-13.3,10.4-22.9,23.6-22.9
                c4.8,0,10.1,0.8,13.7,3.1v14.1c-2.8-2.5-7-3.4-11.8-3.4c-4.5,0-9.8,3.7-9.8,9.6c0,5.1,5.3,8.2,9.8,8.2c5,0,8.1-0.3,11.8-3.1V186.2
                L439.7,186.2z M472.5,175.5v10.7c-11.5,8.5-24.7,1.4-24.7-8.5V158h-5.6v-13h5.6v-10.5l15.7-8.5V145h9v11.9h-8.1v18.4
                C464.3,178.6,469.9,178.3,472.5,175.5L472.5,175.5z M358.9,159.1l2.5-12.1c15.7-5.4,38.1-2.3,38.1,11.9v29.9H385l-0.6-1.4
                c-6.7,4.2-31.4,6.2-28-13.3c2-11.6,15.1-14.4,23.3-14.4c4.2,0,5.9-4,0.6-4.2C375.4,155.1,365.9,155.7,358.9,159.1z M94.2,159.1
                l2.2-12.1c15.7-5.4,38.1-2.3,38.1,11.9v29.9h-14.9l-0.3-1.4c-6.4,4.2-32,6.2-28-13.3c2-11.6,14.9-14.4,23-14.4c4.2,0,5.9-4,0.8-4.2
                C110.5,155.1,100.7,155.7,94.2,159.1z M273.9,167.3c0,13.3-10.9,22.6-24.1,22.6c-13.2,0-24.4-9.9-24.4-23.2
                c0-13,11.2-23.2,24.1-23.2C263,143.6,273.9,153.7,273.9,167.3L273.9,167.3z M353.6,175.5v10.7c-11.8,8.5-24.7,1.4-24.7-8.5V158
                h-5.6v-13h5.6v-10.5l16-8.5V145h8.7v11.9h-8.4v18.4C345.2,178.6,351.1,178.3,353.6,175.5z"
      />
      <path
        fill="#2D78BB"
        d="M68.1,122.9c14.6,0,25.2,19.5,11.8,31.6c16.8,10.5,9.3,33.6-9.5,33.9H39v-65.5H68.1z M222.6,186.2
                c-3.6,2.3-7.9,3.4-12.6,3.4c-13.2,0-24.4-9.6-24.4-22.9c0-13.3,10.4-22.9,23.3-22.9c4.8,0,10.1,0.8,13.7,3.1v14.1
                c-3.1-2.5-6.7-3.4-11.5-3.4c-4.8,0-10.1,3.7-10.1,9.6c0,5.1,5.6,8.2,10.1,8.2c4.8,0,7.9-0.3,11.5-3.1V186.2L222.6,186.2z
                 M182.5,160.2v28.5h-15.7v-24.6c0-8.8-12.6-8.5-12.6,0v24.6h-15.7V145h16v3.7C167.7,138.8,182.5,147.8,182.5,160.2L182.5,160.2z
                 M321.1,160.2v28.5h-15.7v-24.6c0-8.8-12.6-8.5-12.6,0v24.6H277V145h15.7v3.7C306.2,138.8,321.1,147.8,321.1,160.2z M380.2,155.4
                c5.3,0.3,3.6,4.2-0.6,4.2c-8.1,0-21.3,2.8-23.3,14.4c-3.4,19.5,21.3,17.5,28,13.3l0.6,1.4h14.6v-29.9c0-14.1-22.4-17.2-38.1-11.9
                l-2.5,12.1C365.9,155.7,375.4,155.1,380.2,155.4z"
      />
      <path
        fill="#2D78BB"
        d="M115.2,155.4c5,0.3,3.4,4.2-0.8,4.2c-8.1,0-21,2.8-23,14.4c-3.9,19.5,21.6,17.5,28,13.3l0.3,1.4h14.9v-29.9
                c0-14.1-22.4-17.2-38.1-11.9l-2.2,12.1C100.7,155.7,110.5,155.1,115.2,155.4z M249.6,143.6c-12.9,0-24.1,10.2-24.1,23.2
                c0,13.3,11.2,23.2,24.4,23.2c13.2,0,24.1-9.3,24.1-22.6C273.9,153.7,263,143.6,249.6,143.6L249.6,143.6z M345.2,175.2v-18.4h8.4
                V145h-8.7V126l-16,8.5V145h-5.6v13h5.6v19.8c0,9.9,12.9,16.9,24.7,8.5v-10.7C351.1,178.3,345.2,178.6,345.2,175.2L345.2,175.2z"
      />
      <path
        fill="#2D78BB"
        d="M39,122.9v65.5h31.4c18.8-0.3,26.4-23.4,9.5-33.9c13.5-12.1,2.8-31.6-11.8-31.6L39,122.9L39,122.9z
                 M222.6,172.4c-3.6,2.8-6.7,3.1-11.5,3.1c-4.5,0-10.1-3.1-10.1-8.2c0-5.9,5.3-9.6,10.1-9.6c4.8,0,8.4,0.8,11.5,3.4V147
                c-3.6-2.3-9-3.1-13.7-3.1c-12.9,0-23.3,9.6-23.3,22.9c0,13.3,11.2,22.9,24.4,22.9c4.8,0,9-1.1,12.6-3.4V172.4z M154.5,148.7V145
                h-16v43.8h15.7v-24.6c0-8.5,12.6-8.8,12.6,0v24.6h15.7v-28.5C182.5,147.8,167.7,138.8,154.5,148.7L154.5,148.7z M292.7,148.7V145
                H277v43.8h15.7v-24.6c0-8.5,12.6-8.8,12.6,0v24.6h15.7v-28.5C321.1,147.8,306.2,138.8,292.7,148.7L292.7,148.7z M439.7,172.4
                c-3.6,2.8-6.7,3.1-11.8,3.1c-4.5,0-9.8-3.1-9.8-8.2c0-5.9,5.3-9.6,9.8-9.6c4.8,0,9,0.8,11.8,3.4V147c-3.6-2.3-9-3.1-13.7-3.1
                c-13.2,0-23.6,9.6-23.6,22.9c0,13.3,11.5,22.9,24.4,22.9c4.5,0,9.3-1.1,12.9-3.4V172.4z M464.3,175.2v-18.4h8.1V145h-9V126
                l-15.7,8.5V145h-5.6v13h5.6v19.8c0,9.9,13.2,16.9,24.7,8.5v-10.7C469.9,178.3,464.3,178.6,464.3,175.2L464.3,175.2z M258.8,167.3
                c0,4.8-4.2,8.8-9,8.8s-8.7-4-8.7-9.3c0-5.6,3.9-8.8,8.7-8.8S258.8,161.1,258.8,167.3z"
      />
      <path
        fill="#2D78BB"
        d="M56.9,162.2h7c8.7,0,9.5,13.3,0.3,13.3h-7.3V162.2z M118.9,169.6v5.4c0,5.9-11.8,7.6-11.8,1.4
                C107.1,170.7,115.5,169,118.9,169.6z M383.9,169.6v5.4c0,5.9-11.5,7.6-11.5,1.4C372.4,170.7,380.8,169,383.9,169.6z M63.9,136.2
                c8.1,3.7,5.3,12.4,0.3,12.4h-7.3v-12.4C56.9,135.9,62,135.7,63.9,136.2L63.9,136.2z"
      />
      <path
        fill="#FFFFFF"
        d="M249.8,158c-4.8,0-8.7,3.1-8.7,8.8c0,5.4,3.9,9.3,8.7,9.3s9-4,9-8.8C258.8,161.1,254.6,158,249.8,158z
                 M372.4,176.3c0,6.2,11.5,4.5,11.5-1.4v-5.4C380.8,169,372.4,170.7,372.4,176.3z M56.9,136.2v12.4h7.3c5,0,7.9-8.8-0.3-12.4
                C62,135.7,56.9,135.9,56.9,136.2z M107.1,176.3c0,6.2,11.8,4.5,11.8-1.4v-5.4C115.5,169,107.1,170.7,107.1,176.3z M56.9,175.5h7.3
                c9.3,0,8.4-13.3-0.3-13.3h-7V175.5z"
      />
      <path
        fill="#2D78BB"
        d="M233.8,367.3c0-15.3-6.2-25.1-21.6-25.1c-14.6,0-23.3,11-23.3,23.4c0,13.6,10.4,23.4,25,23.4
                c12.6,0,19.1-5.1,19.1-5.1v-13c-5.3,2.8-11.2,4.5-15.4,4.5c-8.4,0-12.9-2.3-12.9-8.2L233.8,367.3L233.8,367.3z M69.3,369.6
                l12.9-18.6v37H99l0.3-64.1H82.2L69.3,343l-13.2-19.2H39l0.3,64.1h16.8v-37L69.3,369.6L69.3,369.6z M252.1,362.2
                c1.7-3.7,5.3-6.8,10.1-6.8c2.5,0,5.3,1.1,7.3,2.5v-13.8c-1.4-1.7-3.6-2.3-5.9-2.3c-3.9,0-9.3,2.3-11.5,5.1v-4.5h-15.1v45.5h15.1
                V362.2L252.1,362.2z M123.1,385.1c5.3,2.3,11.8,3.1,16,3.1c16.3,0,21-8.5,21-15.5c0-8.2-8.4-12.7-16-13.8c-1.1,0-4.2-0.8-4.2-2.3
                c0-1.1,0.8-2.5,4.5-2.5c3.1,0,8.7,1.1,11.5,2.5l-0.6-11.9c-4.2-1.4-10.1-2.5-14.6-2.5c-9.3,0-17.4,5.7-17.4,14.7
                c0,7.1,5,10.7,13.2,12.4c3.4,0.3,6.4,1.7,6.4,3.4c0,2.3-2.2,2.8-4.5,2.8c-2,0-7,0.6-15.4-2.8L123.1,385.1L123.1,385.1z"
      />
      <path
        fill="#2D78BB"
        d="M180.6,374.1v-18.6h8.7v-12.1H180v-19.5l-16,8.5v11h-5.6v13h5.6v20.3c0,10.2,13.2,16.9,25.2,8.5v-11
                C186.7,376.6,180.6,377.2,180.6,374.1L180.6,374.1z M120.3,387.4v-44.1h-16.8v44.1H120.3z M111.9,341.9c5,0,9.3-4.2,9.3-9.3
                c0-4.8-4.2-8.8-9.3-8.8c-4.8,0-8.7,4-8.7,8.8C103.2,337.6,107.1,341.9,111.9,341.9z M388.3,385.1c5.3,2.3,11.8,3.1,16,3.1
                c16.3,0,21.3-8.5,21.3-15.5c0-8.2-8.4-12.7-16.3-13.8c-1.1,0-4.2-0.8-4.2-2.3c0-1.1,0.8-2.5,4.8-2.5c3.1,0,8.4,1.1,11.5,2.5
                l-0.8-11.9c-4.2-1.4-10.1-2.5-14.6-2.5c-9.3,0-17.4,5.7-17.4,14.7c0,7.1,5,10.7,13.2,12.4c3.4,0.3,6.4,1.7,6.4,3.4
                c0,2.3-2.2,2.8-4.5,2.8c-2,0-7,0.6-15.4-2.8L388.3,385.1L388.3,385.1z M339,369.3c-5.3,4-9.5,4.8-16.5,4.8
                c-10.7,0-20.2-8.8-20.2-17.8c0-9.9,5.3-19.2,20.2-19.2c6.7,0,12.3,1.1,16.5,5.1v-15.3c-5.3-3.1-12.6-4-19.1-4
                c-19.4,0-34.2,13.8-34.2,32.8c0,18.6,16.3,32.8,35.3,32.8c6.4,0,12.6-1.4,17.9-4.5V369.3z M365.9,353.2c5.3,0.3,3.6,4.5-0.6,4.5
                c-8.4,0-21.9,2.8-23.6,14.4c-3.6,19.8,21.6,18.1,28.3,13.8l0.6,1.1h15.1v-30.5c0-14.4-23-17.2-39.3-11.9l-2.2,12.1
                C351.3,353.5,361.2,352.9,365.9,353.2L365.9,353.2z M443.6,346.7v-22.9h-15.7v64.1h15.7v-25.1c0-8.5,12.9-8.8,12.9,0v25.1h16v-29.1
                C472.5,345.8,457.3,336.8,443.6,346.7L443.6,346.7z"
      />
      <path
        fill="#FFFFFF"
        d="M204.1,358.5c0.8-4.2,4.2-5.6,7.3-5.6c3.1,0,7,1.4,7,5.6H204.1z M369.6,367.6v5.4c0,6.2-11.8,7.6-11.8,1.4
                C357.8,368.7,366.5,367.3,369.6,367.6L369.6,367.6z"
      />
    </g>
  ),
}
